import axios from "../../interceptors/axiosInterceptor";
import {
    GET_AGENT_LIST_URL,
    UPDATE_AGENT_URL,
    GET_AGENT_ZONES_URL,
    GET_AGENT_TITLE_URL,
    GET_AGENT_TEAM_URL,
    CREATE_AGENT_URL,
    GET_BRAND_URL,
} from "../../config/Url";
import {
    IGetQueryParams,
    IAgentTitle,
    IZonesResponseObject,
    ICreateAgentOnlyReq,
} from "../../interfaces/Index";
import { getAuthOptions } from "../../config/Headers";
import {
    normalizeFetchAgentManagementUserResponse,
    normalizeAgentTitle,
    normalizeAgentTeam,
    normalizeBrands
} from "../../normalizer/AgentManagementNormalizer";
import { normalizeCatchErrors } from "../../utils/errorUtils";

interface IZonePayload {
  zoneIds: string[];
}

export const fetchAgentListApiCall = (queryParam: IGetQueryParams = {}) =>
  new Promise((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(GET_AGENT_LIST_URL, requestConfig)
      .then((response) => {
        if (response) {
          const data = response && response.data;
          const pageNumber: number = queryParam.page
            ? Number(queryParam.page) + 1
            : 1;
          const isPaginatedRes =
            queryParam.page && (queryParam.page as any) > 0 && data.length >= 50
              ? true
              : false;
          resolve(
            normalizeFetchAgentManagementUserResponse(
              data,
              pageNumber,
              isPaginatedRes
            )
          );
        } else {
          reject({ errors: "Something went wrong in agent list" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const getAgentDetailsApiCall = (id: string) =>
  new Promise((resolve, reject) => {
    let url = UPDATE_AGENT_URL.replace("{agent_id}", id);
    axios
      .get(url, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response.data;
          resolve(data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchAgentTitlepiCall = () =>
  new Promise<Array<IAgentTitle>>((resolve, reject) => {
    axios
      .get(GET_AGENT_TITLE_URL, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response && response.data;
          resolve(normalizeAgentTitle(data));
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchAgentTeamApiCall = () =>
  new Promise<Array<IAgentTitle>>((resolve, reject) => {
    axios
      .get(GET_AGENT_TEAM_URL, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response && response.data;
          resolve(normalizeAgentTeam(data));
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const getAllAgentZonesAPICall = (
  id:string = "",
  customerChannel:string = "",
  queryParam: IGetQueryParams = {},
): Promise<IZonesResponseObject[]> => {
  return new Promise((resolve, reject) => {
    let url = GET_AGENT_ZONES_URL.replace("{cityId}", id)
    .replace("{customerChannel}",customerChannel);
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(url, requestConfig)
      .then((response) => {
        if (response) {
          resolve(response.data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
};

export const updateAgent = (agentId: string, payload: any) => {
  return new Promise((resolve, reject) => {
    let url = UPDATE_AGENT_URL.replace("{agent_id}", agentId);
    axios
      .put(url, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve(response.data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
};

export const createAgent = (payload: ICreateAgentOnlyReq) =>
  new Promise<void>((resolve, reject) => {
    axios
      .post(CREATE_AGENT_URL, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve(response.data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchBrandsApiCall = () =>
    new Promise<Array<IAgentTitle>>((resolve, reject) => {
        axios
            .get(GET_BRAND_URL, getAuthOptions())
            .then((response) => {
                if (response) {
                    const data = response && response.data;
                    resolve(normalizeBrands(data));
                } else {
                    reject({ errors: "Something went wrong" });
                }
            })
            .catch((error) => {
                const errorPayload = normalizeCatchErrors(error.response);
                reject(errorPayload);
            });
    });
